export default __webpack_public_path__ + "static/Economic Model Whitepaper - Spanish-99c0c8bea7131d782bd1b9ade8c99bea.pdf";